import React, { Component } from 'react';
export default class FormFieldLabel extends Component {
  constructor () {
    super();
  }

  render () {
    const { children, label } = this.props;
    const renderLabel = children ? children : label;

    return (
      <label className={this.props.className}
        htmlFor={this.props.htmlFor}
        style={this.props.style}>
        {renderLabel}
      </label>
    );
  }
}

FormFieldLabel.defaultProps = {
  className: '',
  htmlFor: '',
};



// WEBPACK FOOTER //
// ./src/common/views/form/FormFieldLabel.js